(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const bootstrapModal = require('bootstrap/js/modal');
    const uniqueId = require('../utils/uniqueId');

    class ModalViewModel {
        constructor(params) {
            this.id = uniqueId();
            this.isOpen = ko.isObservable(params.open) ? params.open : ko.observable(!!params.open);
            this.isOpen.subscribe(value => {
                if (value) {
                    $('#' + this.id).modal('show');
                }
            });
            this.bodyClasses = params.bodyClasses;
            window.setTimeout(() => {
                $('#' + this.id).on('hide.bs.modal', () => {
                    this.isOpen(false);
                });
            }, 0);
        }
    }

    ko.components.register('modal', {
        viewModel: ModalViewModel,
        template:
            `<div class="modal fade" tabindex="-1" role="dialog" data-bind="attr: { id: id }">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Historique</h4>
                        </div>
                        <div class="modal-body" data-bind="template: { nodes: $componentTemplateNodes, data: $parent }, attr: { 'class': 'modal-body ' + bodyClasses }"></div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>`,
    });
})();


// WEBPACK FOOTER //
// ./resources/scripts/components/ko.modal.js